import { render, staticRenderFns } from "./CardSimple.vue?vue&type=template&id=aff46bc4&scoped=true&"
import script from "./CardSimple.vue?vue&type=script&lang=js&"
export * from "./CardSimple.vue?vue&type=script&lang=js&"
import style0 from "./CardSimple.vue?vue&type=style&index=0&id=aff46bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff46bc4",
  null
  
)

export default component.exports